import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  DropdownItem,
  DropdownMenu,
  Dropdown,
  DropdownToggle,
} from "reactstrap";
import { compose, withHandlers } from "recompose";
import shortid from "shortid";
import { get, max, pick } from "lodash";
import { NotificationManager } from "react-notifications";
import { Trans, useTranslation } from "react-i18next";
import deepPick from "deepPick";
import { formatDate } from "services/util";
import { Link } from "react-router-dom";
import {
  FormGroup,
  required,
  Page,
  onMount,
  withReload,
  withLocalForm,
  getStatus,
} from "components/common";
import {
  withXeroErrors,
  LineItemsView,
  Attachments,
  withDocumentRenderer,
  withOptions,
} from "components";
import { QuoteDocument } from "components/documents";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import BackButton from "components/refactoring/BackButton";
import { ConvertToInvoiceButton, DocumentTypeMapping } from "./constants/ConvertToInvoiceButton";
import { DownloadError } from "components/common/ZatcaSelected";
import { useBaseModal } from "services";

const ShareDocument = withDocumentRenderer({
  footer: false,
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `${DocumentTypeMapping[item.DocumentType]}_${item.QuoteNumber}.pdf`,
    ),
})(({ DocumentRenderer, ShareDocument, i, selectedOrganisation, validation }) => (
  <td className="text-end text-left">
    <ShareDocument item={i} wtsp={true} validation={validation}/>
    <DocumentRenderer component={QuoteDocument} selectedOrganisation={selectedOrganisation} />
  </td>
));

let _ViewQuote = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  dispatch,
  handleAttachmentsChanged,
  ContactSearch,
  XeroErrors,
  organisation,
  DocumentRenderer,
  DownloadDocument,
  EmailDocument,
  history,
  form,
  match,
  reload,
  selectedOrganisation,
  t,
  setState,
  ...props
}) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isSending, setSending] = useState(false);
  const [missFields, setMissingFields] = useState([]);
  const [, toggleModal, MainModal] = useBaseModal()

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const isAcceptedOrDeclined = item.Status === "ACCEPTED" || item.Status === "DECLINED"

  const editLink = () => {
    const { QuoteID } = item;

    history.push(`/quotes/edit/${QuoteID}`)
  };

  const handleStatus = async (status) => {
    setSending(true);
    const { Title, Terms, Summary, Reference, ExpiryDate, Date, Contact, QuoteID, QuoteNumber, LineItems } = item;

    const filteredItem = { QuoteID, QuoteNumber, LineItems, Title, Terms, Summary, Reference, ExpiryDate, Date, Contact, Status: status };

    try {
      await xero.put(`quotes/${match.params.id}`, filteredItem);
      setTimeout(() => {
        NotificationManager.success(t(`Marked as ${status.toLowerCase()} successfully`));
        setSending(false);
        setTimeout(() => {
          reload();
        }, 1500);
      }, 5000);
    } catch (err) {
      NotificationManager.error(t("Unexpected Error Occurred"));
      setSending(false);
    }
  };

  const textColor = "#525F7F"

  const SpanColor = ({ children, color }) => {
    const colorInheritStyle = {
      color: color || textColor,
      fontSize: "1.2em",
    };

    return <span style={colorInheritStyle}>{children}</span>;
  };

  const checkInvoiceDownload = (isWtspShare = false) => {

    let contactMobile = item?.Contact?.Phones?.find((phone) => phone.PhoneType === "MOBILE")
    let isValidPhoneNumber = !isWtspShare || (contactMobile.PhoneNumber && contactMobile.PhoneCountryCode)

    const missing_fields = []

    if (!isValidPhoneNumber) {
      missing_fields.push('PhoneNumber')
    }

    setMissingFields(missing_fields)

    if (!(isValidPhoneNumber)) {
      toggleModal();
      return false;
    } else {
      return true;
    }
  };

  return (
    <div>
      <Page
        title={(`View Quote ${item.QuoteNumber || ""}`)}
        translate={false}
      >
        <BackButton />
        <br />
        <XeroErrors />

        <DocumentRenderer component={QuoteDocument} selectedOrganisation={selectedOrganisation} />
        <div className="d-flex align-items-center" style={{ paddingBottom: 20 }}>
          <div className="mx-auto" />
          {!!(item.QuoteID && item.Attachments) && (
            <Attachments
              xero={xero}
              onAttachmentsChanged={handleAttachmentsChanged}
              baseUrl={`quotes/${item.QuoteID}`}
              attachments={item.Attachments}
            />
          )}
          {!!item.QuoteID && <DownloadDocument className="ml-2 mr-2" />}
          {!!item.QuoteID && <EmailDocument type="QUOTE" item={item} />}
          <div className="mx-1" />
          {!!item.QuoteID && <ShareDocument i={item} selectedOrganisation={selectedOrganisation} validation={() => checkInvoiceDownload(true)}/>}
          {!!item.QuoteID && (
            <ConvertToInvoiceButton
              disabled={!form.$form.valid}
              color="success"
              size="sm"
              item={item}
            />
          )}
          {!!item.QuoteID && item.Status !== "INVOICED" &&
            <>
              {!isSending ?
                <Dropdown size="sm" isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle className="ml-0" caret>
                    <Trans>{isAcceptedOrDeclined ? t("Unmark") : t("Mark as")}</Trans>
                  </DropdownToggle>
                  <DropdownMenu>
                    {item.Status === "DRAFT" &&
                      <DropdownItem onClick={() => handleStatus("SENT")}>
                        <Trans>Sent</Trans>
                      </DropdownItem>
                    }
                    {item.Status === "SENT" &&
                      <>
                        <DropdownItem onClick={() => handleStatus("ACCEPTED")}>
                          <Trans>Accepted</Trans>
                        </DropdownItem>
                        <DropdownItem onClick={() => handleStatus("DECLINED")}>
                          <Trans>Declined</Trans>
                        </DropdownItem>
                      </>
                    }
                    {isAcceptedOrDeclined &&
                      <DropdownItem onClick={() => handleStatus("SENT")}>
                        <Trans>Revert to Sent</Trans>
                      </DropdownItem>
                    }
                    {/* <DropdownItem onClick={() => handleStatus("DELETED")}>
                    <span className="text-danger"><Trans>Delete</Trans></span>
                  </DropdownItem> */}
                  </DropdownMenu>
                </Dropdown>
                :
                <Button disabled size="sm" className="ml-0"><span className="fa fa-fw fa-spin fa-spinner" /> <Trans>Saving</Trans></Button>
              }
            </>
          }
          {!!item.QuoteID &&
            <button
              type="button"
              className="btn-sm btn btn-primary ml-0"
              onClick={editLink}>
              <Trans>Edit Quote</Trans>
            </button>
          }
        </div>
        <LocalForm
          onSubmit={onSubmit}
          validators={{
            Contact: { required },
            Date: { required },
            "LineItems[].Description": { required },
          }}
        >
          <Row>
            <Col xs={false} md={3}>
              <FormGroup label="To" model=".Contact" addControlClass={false} className="pt-2 pb-2" >
                <Link to={`/contacts/view/${item.Contact.ContactID}`} style={{ color: '#72B566', fontWeight: 'bold', fontSize: '1.3em' }}>
                  {item.Contact.Name || "---"}
                </Link>
              </FormGroup>
            </Col>
            <Col xs={false} md={3}>
              <FormGroup label="Status" className="pt-2 pb-2">
                <SpanColor color={item.Status === "DECLINED" || item.Status === "DELETED" ? "red" : item.Status === "ACCEPTED" ? "#72B566" : ""}>{getStatus(item.Status) || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col xs={false} md={3} className="pt-2 pb-2">
              <FormGroup label="Date" model=".Date">
                <SpanColor>{formatDate(item.Date) || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col xs={false} md={3} className="pt-2 pb-2">
              <FormGroup label="Expiry Date" model=".ExpiryDate">
                <SpanColor>{formatDate(item.ExpiryDate) || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col xs={false} md={3} className="pt-2 pb-2">
              <FormGroup label="Quote #" model=".QuoteNumber">
                <SpanColor>{item.QuoteNumber || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col xs={false} md={3}>
              <FormGroup label="Reference" model=".Reference" className="pt-2 pb-2">
                <SpanColor>{item.Reference || "---"}</SpanColor>
              </FormGroup>
            </Col>

            <Col xs={false} md={3}>
              <FormGroup label={t("Document Type")} model=".DocumentType" className="pt-2 pb-2">
                <SpanColor>{DocumentTypeMapping[item.DocumentType] || "---"}</SpanColor>
              </FormGroup>
            </Col>
          </Row>
          <div style={{ marginTop: "20px" }}>
            {item.Title && (
              <FormGroup label="Title" model=".Title" className="pt-2 pb-2">
                <span style={{ color: textColor }}>{item.Title}</span>
              </FormGroup>
            )}
            {item.Summary && (
              <FormGroup label="Summary" model=".Summary" className="pt-2 pb-2">
                <span style={{ color: textColor }}>{item.Summary}</span>
              </FormGroup>
            )}
          </div>
          <p style={{ marginTop: "20px", color: "#8E9CA7", fontStyle: 'italic' }}>
            <Trans>Note: This is a quotation and the values might change after it's expiry date.</Trans>
          </p>
          <hr />
          <LineItemsView
            organisation={organisation}
            item={item}
            dispatch={dispatch}
            xero={xero}
            hideAddLines={true}
            hideAccountAndTax={false}
            invoiceType="Quote"
            includeDiscount
          />
          <hr />
          {item.Terms && (
            <FormGroup label="Terms" model=".Terms" className="pt-2 pb-2">
              <SpanColor>{item.Terms}</SpanColor>
            </FormGroup>
          )}
        </LocalForm>
        <MainModal title={t('Set Contact details')}>
          <DownloadError setInvoice={setState} item={item} toggle={toggleModal} history={history} missFields={missFields} callbackFunc={reload} />
        </MainModal>
      </Page>
    </div>
  );
};

const pickQuote = (item) => {
  const allowedProps = [
    "Contact.ContactID",
    "Date",
    "ExpiryDate",
    "LineAmountTypes",
    "LineItems",
    "SubTotal",
    "TotalTax",
    "Total",
    "TotalDiscount",
    "CurrencyCode",
    "CurrencyRate",
    "QuoteID",
    "QuoteNumber",
    "Reference",
    "Title",
    "Summary",
    "Terms",
  ];

  const allowedItem = deepPick(item, allowedProps);

  allowedItem.ExpiryDate = allowedItem.ExpiryDate || undefined;

  return allowedItem;
};

const enhance = compose(
  withOrganisationContextConsumer,
  withReload(),
  onMount(({ match, xero, location, fetchOrganisation }) => async () => {
    const { id } = match.params;
    let item = null;

    if (id === "new") {
      item = get(location, "state.copy") || {
      };
    } else {
      item = xero
        .get(`quotes/${match.params.id}`)
        .get("data")
        .then(async (item) => {
          const contact = await xero.get(`contacts/${item.Contact.ContactID}`).get("data");
          return {
            ...item,
            Contact: contact,
            LineAmountTypes: {
              EXCLUSIVE: "Exclusive",
              INCLUSIVE: "Inclusive",
              NONE: "NoTax",
            }[item.LineAmountTypes],
            LineItems: item.LineItems.map((i) => {
              const line_amount = (i.LineAmount + i.TaxAmount)
              const unit_amount = line_amount / (1 - (i.DiscountRate ?? 0) / 100) / max([i.Quantity, 1])
              return {
                ...i,
                _id: shortid(),
                LineAmount: item.LineAmountTypes === 'INCLUSIVE' ? line_amount : i.UnitAmount,
                UnitAmount: item.LineAmountTypes === 'INCLUSIVE' ? unit_amount.toFixed(4) : i.UnitAmount,

              }
            }),
          }
        });
    }

    return Promise.props({
      item,
      organisation: fetchOrganisation(),
    });
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withXeroErrors(),
  withOptions(),
  withDocumentRenderer({
    footer: false,
    onDownload:
      ({ item }) =>
        (getDocument) =>
          getDocument(
            {
              item: {
                ...item,
                LineAmountTypes: item.LineAmountTypes,
                LineItems: item?.LineItems?.map((i) => ({
                  ...i,
                  _id: shortid(),
                  UnitAmount: item.LineAmountTypes === 'INCLUSIVE' ? ((i.LineAmount + i.TaxAmount + (i.DiscountAmount ?? 0)) / i.Quantity).toFixed(2) : i.UnitAmount,
                  // LineAmount: item.LineAmountTypes === 'INCLUSIVE' ? i.LineAmount + i.TaxAmount : i.LineAmount
                })),
              },
            },
            `${DocumentTypeMapping[item.DocumentType] || 'Quote'}_${item.QuoteNumber}.pdf`
          ),
    type: "QUOTE",
  })
);

export const ViewQuote = enhance(_ViewQuote);
